import axios from 'axios'
import store from './store/store'

const IS_PRODUCTION = process.env.NODE_ENV === 'production'
const API_URL = IS_PRODUCTION ? '' : process.env.VUE_APP_AXIOS_URL

const $axios = axios.create({
    baseURL: API_URL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json' }
})

// Request Interceptor
$axios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.state.profile.token}`
    return config
})

// Response Interceptor to handle and log errors
$axios.interceptors.response.use(
    response => response,
    error => {
        // Handle Error
        console.log(error)
        if (error.response.status === 401) {
            console.log('unauthorized, logging out ...')
            store.commit('logout')
        }
        return Promise.reject(error)
    }
)

export default $axios
